import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";

@Injectable({
   providedIn: 'root'
})
export class CategoriaFactory {

   constructor() {
   }

   async getCategorie(vendorSlug=null):Promise<Categoria[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/categorie` : `/api/categorie`
      return new Promise((resolve, reject) => {
         ServerService.instance.getAll(Categoria, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }
   //
   // async postCategoria(data):Promise<Categoria[]> {
   //    return new Promise((resolve, reject) => {
   //       ServerService.instance.post( `/api/categorie`, data, Categoria).then(res=>{
   //          resolve(res)
   //       }).catch(err=>{
   //          reject(err)
   //       })
   //    })
   // }
   //
   // async putCategoria(categoriaId, data):Promise<Categoria[]> {
   //    return new Promise((resolve, reject) => {
   //       ServerService.instance.put( `/api/categorie/${categoriaId}`, data, Categoria).then(res=>{
   //          resolve(res)
   //       }).catch(err=>{
   //          reject(err)
   //       })
   //    })
   // }

   // async deleteCategoria(categoriaId):Promise<Categoria[]> {
   //    return new Promise((resolve, reject) => {
   //       ServerService.instance.delete( `/api/categorie/${categoriaId}`, {}, Categoria).then(res=>{
   //          resolve(res)
   //       }).catch(err=>{
   //          reject(err)
   //       })
   //    })
   // }

}

export class CategoriaData {
  id?: any;
  nome?: string;
  parent?: number;
  image?: string;
}

export class Categoria {

  data:CategoriaData = {}

  constructor(data:CategoriaData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/categorie`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }



}
